<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{$t('POS-Cost-Report')}} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"  :label="this.$t('Search')">
              </v-text-field>

              <v-menu bottom="" left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>



              <v-flex xs12 sm2 md2 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{genelToplam.ToplamPuan}}

                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="caption font-weight-bold"> {{ $t('Total-Score') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm2 md2 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{genelToplam.ToplamPosMaliyet | moneyformat }}{{getparabirimi()}}

                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="caption font-weight-bold"> {{$t('Total-POS-Cost')}}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm2 md2 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{genelToplam.ToplamVadeFark | moneyformat }}{{getparabirimi()}}

                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="caption font-weight-bold">{{ $t('Total-Delay-Interest') }}</span>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 sm2 md2 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{genelToplam.ToplamTutar | moneyformat }}{{getparabirimi()}}

                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{$t('totalnumber')}}</span>

                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 sm4 md4 pa-1>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">add_comment</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm3 md12>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{genelToplam.ToplamKazanc | moneyformat }}{{getparabirimi()}}


                                </span>
                              </v-list-tile-title>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="caption font-weight-bold"> {{ $t('Total-Gain') }}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>






            </v-layout>
          </v-container>

          <v-container fluid>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>

                      <v-flex xs12 sm6 pt-2 md2>
                        <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 pt-2 sm6 md2>
                        <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"
                          v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout align-center="">
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout align-center="">
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">
                                check_circle_outline </v-icon>
                            </template>

                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>



                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <!-- <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="#66BB6A">
                              <v-toolbar-title> <span class="subheading white--text">
                                  BSFormu
                                </span> </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-flex xs6 sm6 md6>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"  :label="this.$t('Search')"
                                  append-icon="search"></v-text-field>
                              </v-flex>
                            </v-toolbar>

                          </v-flex> -->




                          <v-flex xs12 md12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headersbs" :items="itemsbs" :search="searchsatilanbilet">

                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td class="text-xs-left">{{ props.item.BankaKod }}</td>
                                    <td class="text-xs-left">{{props.item.BankaAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.KotaKod }}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }} </td>
                                    <td class="text-xs-left">{{ props.item.Vade | dateformat}} </td>
                                    <td class="text-xs-right">{{ props.item.Tutar | moneyformat}} </td>
                                    <td class="text-xs-right"> {{ props.item.Puan}}</td>
                                    <td class="text-xs-right"> {{ props.item.VadeFark| moneyformat}}</td>
                                    <td class="text-xs-right"> {{ props.item.PosMaliyet | moneyformat}}</td>
                                    <td class="text-xs-right"> {{ props.item.Kazanc | moneyformat}}</td>
                                    <td class="text-xs-center"> {{ props.item.Taksit  }}</td>

                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>




                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>



          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card color="grey lighten-5">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">


                  <v-flex xs12 sm12 md12 pa-1>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">

                            <v-flex xs12 sm12 md12>

                              <v-autocomplete hide-details tabindex="1" :label="$t('Select-Bank')" :items="bankaitems"
                                clearable="" item-text="BankaAdi" cache-items="" item-value="BankaKod"
                                v-model="Rapor.BankaKod"></v-autocomplete>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-autocomplete hide-details tabindex="1" :label="$t('Select-Quota-Code')" :items="kotaitems"
                                clearable="" cache-items="" v-model="Rapor.Kotakod"></v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.VadeTarih" :label="$t('Maturity-Date')" hide-details=""></v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.OzetRapor" :label="$t('Summary-Report')" hide-details=""></v-checkbox>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Rapor.TaksitToplamRapor" :label="$t('Report-with-Instalment-Total')"
                                hide-details=""></v-checkbox>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"
  import parainput from "@/components/app/customcomp/parainput.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"


  export default {
    data() {
      return {
        PB:'TRY',
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        kotaitems: [],
        bankaitems: [],

        genelToplam: {
          ToplamKazanc: 0,
          ToplamPosMaliyet: 0,
          ToplamPuan: 0,
          ToplamTutar: 0,
          ToplamVadeFark: 0
        },

        ToplamAdet: 0,
        GenelDipToplam: 0,
        search: '',
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,


        headersbs: [{
            text: this.$t('Bank'),
            value: 'BankaKod',
          },
          {
            text: this.$t('Bank-Name'),
            value: 'BankaAdi',
          },
          {
            text: this.$t('Quota'),
            value: 'KotaKod',
          },
          {
            text: this.$t('Date'),
            value: 'Tarih',
          },
          {
            text: this.$t('Maturity'),
            value: 'Vade',
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
          },
          {
            text: this.$t('Point'),
            value: 'Puan',
          },
          {
            text: this.$t('Delay-interest'),
            value: 'VadeFark',
          },
          {
            text: this.$t('POS-Cost'),
            value: 'PosMaliyet',
          },
          {
            text: this.$t('Earning'),
            value: 'Kazanc',

          },
          {
            text: this.$t('Instalment'),
            value: 'Taksit',
          }
        ],



        Rapor: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          BankaKod: null,
          Kotakod: null,
          VadeTarih: false,
          OzetRapor: false,
          TaksitToplamRapor: false,
        },

        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        valid: true,
        tumsirketler: '',
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsbs: [],



        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,

    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
        this.$http.post(auth.API_URL + 'api/Definitions/QuotaList', null, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.kotaitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-QuotaList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-QuotaList'
            this.snackbar = true
          }
        })

        var params = {
          CompanyCode: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/Bank/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.bankaitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Bank/List'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Bank/List'
            this.snackbar = true
          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      parainput,
      havayollaricomp,
      yetkidialog
    },
    watch: {
    },
    methods: {
          getparabirimi() {
        return helpers.getparabirimi()
      },
      git(v) {
        var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v
          .GenelBilgileri.BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
        window.open(url, '_blank')
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  }


  function filtrele() {
    this.dialogfiltre = true

  }



  function filtrekayit() {
    this.dialogfiltre = false
    this.filtrevarmi = true
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.tumsirketler = false
    this.Rapor.BankaKod = null
    this.Rapor.Kotakod = null
    this.Rapor.VadeTarih = false
    this.Rapor.OzetRapor = false
    this.Rapor.TaksitToplamRapor = false
  }


  function getList() {

    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/Report/PosCostReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsbs = response.body.DetayList
          this.genelToplam = response.body
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }



  function getListHtml() {


    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var lang = localStorage.getItem('lang')
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Report/PosCostReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          if (lang=='en')
          {
            
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> POS MALİYET RAPORU </title>','<title> POS COST </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>POS MALİYET RAPORU</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>POS COST</font>")
             bodyhtml=bodyhtml.toString().replace("Banka Code :","Bank Code :")  
             bodyhtml=bodyhtml.toString().replace("Pos Maliyet","Pos Cost")
             bodyhtml=bodyhtml.toString().replace("Vade Farkı","Maturity Difference")
             bodyhtml=bodyhtml.toString().replace("Kazanç","Profit")
             bodyhtml=bodyhtml.toString().replace("Taksit","Installment")
             bodyhtml=bodyhtml.toString().replace("Banka","Bank")
             bodyhtml=bodyhtml.toString().replace("TOPLAM :","TOTAL :")
            	
             response.bodyText=bodyhtml;
             
          }
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('PosMaliyet') + ".html";
          link.click();



        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListExcel() {


    if (this.$refs.formgunluksatis.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        var params = this.Rapor

        this.$http.post(auth.API_URL + "api/Report/PosCostReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {

          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('PosMaliyet') + ".xlsx";;
          link.click();


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function beforeMount() {

  }
</script>
<style>
</style>